module.exports = __webpack_public_path__ + "static/img/257_TO8_2319.3886af4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/257_TO8_2319.jpg
// module id = EpKP
// module chunks = 0